export const baseColor = "#999";
export const layoutWidth = "1070px";